const sessions = {
  ES653fbd8e15cb6f783b4f4b2ab9523297: {
    firstName: 'Erik',
    lastName: 'Nermo',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'review',
    routedAt: 1740059195189,
  },
  ES651583b4ff329cb643b2abf77bd8e952: {
    firstName: 'Daryl',
    lastName: 'Hall',
    reviewBy: 'PU123456',
    inRoomAt: 1740059195189,
    location: 'waiting',
    routedAt: 1740059195189,
  },
  ES651583b4ffbd8e952329cb643b2abf77: {
    firstName: 'Sally',
    lastName: 'Jones',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES6515cbb4f43b2ab9523297fbd8e6f783: {
    firstName: 'Bob',
    lastName: 'Smith',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES65153b2ab9523297fbd8ecb6f783b4f4: {
    firstName: 'Peter',
    lastName: 'McGill',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES3b2ab9523297fbd8e6515cb6f783b4f4: {
    firstName: 'Tommy',
    lastName: 'Jones',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES6515cb6f783b23297fbd8e4f43b2ab95: {
    firstName: 'Erik',
    lastName: 'Smith',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES6515cbb2ab9523297fbd8e6f783b4f43: {
    firstName: 'Emily',
    lastName: 'Block',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES6515cb6fab9523297fbd8e83b4f43b2: {
    firstName: 'Tammy',
    lastName: 'Right',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES6515cb4f43b2ab9523297fbd8eb6f783: {
    firstName: 'Hudson',
    lastName: 'Toplinski',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES653b2ab9523297fbd8e15cb6f783b4f4: {
    firstName: 'Mac',
    lastName: 'Donalds',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'testing',
    routedAt: 1740059195189,
  },
  ES2329cb643b2abf77651583b4ffbd8e95: {
    firstName: 'Matthew',
    lastName: 'BUnderhill',
    reviewBy: null,
    inRoomAt: 1740059195189,
    location: 'waiting',
    routedAt: 1740059195189,
  },
};

export default sessions;
